type NovoCheckoutInputs = {
  isNovoBuyflowEnabled: boolean;
  isMembershipPlan: boolean;
  isBrandedPlan: boolean;
};

/**
 * One switch for every Novo change (plan card, order summary, disclaimers).
 * On for a membership plan or MED_SKU.BRANDED while the Novo buyflow is
 * enabled. The other branded SKUs stay on the legacy checkout.
 */
export const shouldShowNovoCheckout = ({
  isNovoBuyflowEnabled,
  isMembershipPlan,
  isBrandedPlan,
}: NovoCheckoutInputs): boolean =>
  isNovoBuyflowEnabled && (isMembershipPlan || isBrandedPlan);
